/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import TextWidget from './TextWidget';
import Button from '../../common/Button';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

/**
 * Custom widget for the EPVAL publication number containing a text widget for a value
 * and a button that should be used to validate the input value.
 *
 * Widget custom properties:
 * ui:button-text - uiSchema property for button label
 * ui:button-hidden - uiSchema property that removes the button when true
 */
export default function PublicationNumberWidget(props) {
  const classes = useStyles();
  const { uiSchema, disabled, rawErrors = [], rawHelp = [] } = props;

  const buttonText = uiSchema?.['ui:button-text'];
  const buttonHidden = uiSchema?.['ui:button-hidden'];
  const isDisabled = uiSchema?.['ui:disabled'] || disabled;

  const hasError = rawErrors?.length > 0 || uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'error';
  const hasWarning = rawHelp?.length > 0 && uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'info';

  return (
    <div className={clsx(classes.container)}>
      <TextWidget {...props} size="small" error={rawErrors.length > 0} hasError={hasError} hasWarning={hasWarning} />
      {!buttonHidden && (
        <Button id="publication-number-check" disabled={isDisabled}>
          {buttonText}
        </Button>
      )}
    </div>
  );
}
